import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import classes from './ManualAttendance.module.scss';
import { manualAttendance } from '../../API/API';

const ManualAttendanceForm = ({applySuccess}) => {
    const today = new Date()
    let tomorrow = new Date(today)

    const maxDate = tomorrow.toISOString().substring(0, 10)

    const userID = localStorage.getItem('userID');
    const data = JSON.parse(localStorage.getItem('data'));

    const navigate = useNavigate();

    const [site, setSite] = useState([]);
    const sites = localStorage.getItem('location');
    const [values, setValues] = useState({
        date: "",
        inTime: "09:30",
        inFrom: "",
        outTime: "18:00",
        outFrom: "",
        remarkVal: "",
    })


    const { date, inTime, inFrom, outTime, outFrom, remarkVal } = values;

    useEffect(() => {
        if (sites !== null) {
            setSite(JSON.parse(sites))
        }
    }, [])

    const handleDate = (event) => {
        event.preventDefault();

        setValues({ ...values, date: event.target.value })
    }

    const handleInFrom = (event) => {
        setValues({ ...values, inFrom: event.value })
    }
    const handleInTime = (event) => {
        event.preventDefault();
        setValues({ ...values, inTime: event.target.value })
    }
    const handleOutTime = (event) => {
        event.preventDefault();
        setValues({ ...values, outTime: event.target.value })
    }
    const handleOutFrom = (event) => {
        setValues({ ...values, outFrom: event.value })
    }
    const handleRemarks = (event) => {
        event.preventDefault();
        setValues({ ...values, remarkVal: event.target.value })
    }



    const applyManualAtt = async (event) => {
        event.preventDefault()
        console.log(values)


        if (data !== null && userID !== null) {

            if (Object.values(values).includes("") === true) {
                toast("Kindly Enter All Your Details", {
                    icon: '❗',
                });

                return;
            }
            try {
                const response = await manualAttendance(userID, data.empid, data.token, date, inTime, inFrom, outTime, outFrom, remarkVal);

                if (response.data.value === "OK") {
                    toast.success("Your Attendance has been sent to your Reporting Officer", {
                        duration: 4500
                    })
                    
                    // setValues({
                    //     date: "",
                    //     inTime: "09:30",
                    //     inFrom: "",
                    //     outTime: "18:00",
                    //     outFrom: "",
                    //     remarkVal: "",
                    // })

                    applySuccess(true)

                } else {
                    toast.error("Try After Sometime", {
                        duration: 4500
                    })
                    navigate('/dashboard/home')
                }

            } catch (error) {
                toast.error('Problem in sending Manual Attendance please try again later', {
                    duration: 4000
                })
            }

        }


    }





    return (
        <>
            <form className={classes.FormDiv} onSubmit={applyManualAtt}>
                <label htmlFor="Date">
                    Date
                    <input type="date" name='Date' placeholder='Enter Date' onChange={handleDate} value={date} max={maxDate} required />
                </label>
                <label htmlFor="InLocation">
                    In Location
                    <Select
                        options={site.map((item, index) => ({
                            value: item.location,
                            label: item.location ? item.location.replace(/_/g, " ") : " "
                        }))}
                        placeholder="Enter Location"
                        onChange={handleInFrom}
                        isSearchable={true}
                        classNamePrefix='filter'
                    />
                    {/* <select type="text" name="InLocation" defaultValue={"placeholder"} onChange={handleInFrom} placeholder='Enter In Location' required>
                            <option disabled value={"placeholder"} hidden>In Location</option>
                            {site.map((item, index) => {
                                return <option key={index} value={item.location}>{item.location ? item.location.replace(/_/g, " ") : " "}</option>
                            })}
                        </select> */}
                </label>
                <label htmlFor="InTime">
                    In Time
                    <input type="time" placeholder='In Time' onChange={handleInTime} value={inTime} required />
                </label>

                <label htmlFor="OutLocation">
                    Out Location
                    <Select
                        options={site.map((item, index) => ({
                            value: item.location,
                            label: item.location ? item.location.replace(/_/g, " ") : " "
                        }))}
                        placeholder="Enter Location"
                        onChange={handleOutFrom}
                        isSearchable={true}
                        classNamePrefix='filter'
                    />
                    {/* <select type="text" name="OutLocation" defaultValue={"placeholder"} onChange={handleOutFrom} placeholder='Enter Out Location' required>
                            <option disabled value={"placeholder"} hidden >Out Location</option>
                            {site.map((item, index) => {
                                return <option key={index} value={item.location}>{item.location ? item.location.replace(/_/g, " ") : " "}</option>
                            })}
                        </select> */}
                </label>

                <label htmlFor="OutTime">
                    Out Time
                    <input type="time" placeholder='Out Time' onChange={handleOutTime} value={outTime} required />
                </label>

                <label htmlFor="remarks">
                    Remarks
                    <input placeholder='Enter Remarks...' required onChange={handleRemarks} value={remarkVal}/>
                </label>


                <button type='submit'>
                    Send For Approval
                </button>
            </form>
        </>
    )
}

export default ManualAttendanceForm
